export default "__VITE_ASSET__DAdH_13H__"